/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import moment from 'moment';
import { Button } from 'react-toolbox/lib/button';
import { sortApptsByDate, filterApptsByTodayOrLater } from '../../../../../../../../utils/dateUtils';
import { DropdownDiv, ContainerDiv } from './styledComponents';
import Card from 'components/Card';
import S from '../styles.scss';
import { RAILS_DATE, MOMENT_TIME, DISPLAY_DATE, NON_LHI_SOURCES,
         IFI_PHONE_NUMBER, SPIG_PHONE_NUMBER } from '../../../../../../../../shared/config/constants';

const SURVEY_REMINDER = `Once your installation is complete, Lowe's will be reaching out via text or email to complete a survey.
They will ask about our craftsmanship, professionalism, and your likelihood to recommend Lowe's and Service Pros to your family or friends.
The survey is very important to us and only 10s are passing scores.
If for any reason you feel we are not earning a 10, please reach out so we can assist with a resolution.`;

const JobReviewScript = (props) => {
  const { phase: { appointments, source, surface_type: { id: surfaceId, name: surfaceName },
          phase_specific: { need_move_furniture }, workroom: { name: workroomName } },
          title, customerAnswered, movingFurniture,
          handleSpecificAnswered, originalFurnitureStatus } = props;
  const isCarpet = surfaceName && surfaceName.trim().toLowerCase() === 'carpet';
  const formatDate = date => moment(date, RAILS_DATE).format(DISPLAY_DATE);
  const formatTime = time => moment(time, MOMENT_TIME).format('h:mm A');
  const didAnswer = customerAnswered === 'yes';
  const appt = sortApptsByDate(filterApptsByTodayOrLater(appointments, true), true)[0] || {};
  const lhiScript = !workroomName.includes('PFT-') && !NON_LHI_SOURCES.includes(source);
  const ifiPhase = source === 'IFI';
  const surveyElement = (<Fragment>
    <br />
    <p>{SURVEY_REMINDER}</p>
  </Fragment>);
  const ifiSurveyElement = (<Fragment>
    <br />
    <p>
      Once your installation is complete, Lowe&apos;s will be reaching out via text or email to complete a survey.
      They will ask about our craftsmanship, professionalism, and your likelihood to recommend Lowe&apos;s and Integrity First to your family or friends.
      The survey is very important to us and only 10s are passing scores.
      If for any reason you feel we are not earning a 10, please reach out so we can assist with a resolution.
    </p>
  </Fragment>);
  const appointmentLine = (<p>
    We have you scheduled for <span className={S.scriptText}>{formatDate(appt.start_date)}</span>,
    with an arrival window of <span className={S.scriptText}>{formatTime(appt.arrival_start_time)} - {formatTime(appt.arrival_end_time)}</span>
  </p>);
  return (<Card className={S.card}>
    <div className={S.headerContainer}>
      <h4 className={S.title}>{`${title} ${didAnswer ? 'Answered' : 'Voicemail'}`} Script</h4>
    </div>
    <div className={S.scriptContainer}>
      {ifiPhase ? (<Fragment>
        {didAnswer ? (<Fragment>
          {appointmentLine}
          <br />
          <p>I need to confirm a few things with you, real quick.</p>
          <br />
          <p className={S.scriptUserNote}>USER NOTE: Check contractor notes.</p>
          <br />
          <p>I see that we are installing (product) in (location).</p>
          <br />
          <p>Have you had a chance to clear the area of any furniture and personal belongings where the installation will take place?</p>
          <br />
          <p className={S.scriptUserNote}>YES: That&apos;s great! USER NOTE: Move to next question.</p>
          <p className={S.scriptUserNote}>NO: No worries! We just ask that the installation area be cleared of furniture and personal belongings before our installers arrive. Will you be able to get that taken care of before your appointment?</p>
          <p className={S.scriptUserNote}>&nbsp;&nbsp;&nbsp;&nbsp;YES: That&apos;s great. Thank you so much. USER NOTE: Move to next question.</p>
          <p className={S.scriptUserNote}>&nbsp;&nbsp;&nbsp;&nbsp;NO: I completely understand! Unfortunately, our installers are unable to move furniture or personal items. We want to make sure your installation goes smoothly, so we&apos;ll need to reschedule your appointment for a time when the area can be cleared. Let&apos;s find a date that works best for you!</p>
          <br />
          <p className={S.scriptUserNote}>
            USER NOTE: Check contractor notes, photos, and detail for CUSTOMER RESPONSIBILITIES. Are there any security systems, doorbell-cameras, shutters, blinds, etc (any fixtures) that need to be removed and reinstalled by the customer. If the project and/or customer indicate removal/reinstallation is needed:
          </p>
          <br />
          <p>As a friendly reminder, please remove your _______ and note that the installers will not be able to reinstall them.</p>
          {ifiSurveyElement}
          <br />
          <p>Do you have our customer care number in case you need anything during your installation?</p>
          <br />
          <p>We look forward to helping you complete your project.</p>
          <br />
          <p>Thank you and have a great day!</p>
        </Fragment>) : (<Fragment>
          {appointmentLine}
          <br />
          <p>Just a reminder to ensure the installation area is cleared of all furniture, personal items, security systems, and/or any shutters/blinds.</p>
          <br />
          <p>If any of this information is incorrect, please call us back at {IFI_PHONE_NUMBER}.</p>
          {ifiSurveyElement}
          <br />
          <p>We look forward to helping you complete your project. Thank you and have a great day!</p>
        </Fragment>)}
      </Fragment>) : (<Fragment>
        <p>
          We have you scheduled for <span className={S.scriptText}>{formatDate(appt.start_date)}</span>,
          with an arrival window of <span className={S.scriptText}>{formatTime(appt.arrival_start_time)} - {formatTime(appt.arrival_end_time)}</span>
        </p>
        <br />
        {didAnswer ? (<Fragment>
          <p>I need to confirm a few things with you, real quick.</p>
          <br />
          <p>I see that we are installing in the _____ rooms of the home.</p>
          <br />
          <p className={S.scriptUserNote}>USER NOTE: Check contractor notes for rooms.</p>
          {isCarpet && (
            <Fragment>
              <br />
              <p>Can we review seam placement together?</p>
              <br />
              <p className={S.scriptUserNote}>USER NOTE: Review seam placement.</p>
            </Fragment>
          )}
          <br />
          <p>
            It looks like we are {originalFurnitureStatus ? 'moving furniture. Is that correct?' : 'not moving furniture. Has that changed?'}
          </p>
          <br />
          <Button
            label="YES"
            flat inverse ripple
            disabled={movingFurniture === 'yes'}
            className={S.standardButton}
            onClick={() => handleSpecificAnswered('movingFurniture', 'need_move_furniture', true)}
          />
          <Button
            label="NO"
            flat inverse ripple
            disabled={movingFurniture === 'no'}
            className={S.standardButton}
            onClick={() => handleSpecificAnswered('movingFurniture', 'need_move_furniture', false)}
          />
          <br />
          {movingFurniture && <ContainerDiv>
            <DropdownDiv condition={movingFurniture}>
              {need_move_furniture !== originalFurnitureStatus && <Fragment>
                <br />
                <p>No problem; I will adjust this now. {lhiScript ? 'Lowe\'s will reach out regarding an adjustment to the price.' : ''}.</p>
              </Fragment>}
              {movingFurniture === 'yes' && <Fragment>
                <br />
                <p>We will:</p>
                <ul>
                  <li className={S.listItem}>{'\u2022'} Move all furnishings, but request that they are emptied and that bedding is stripped.</li>
                </ul>
                <p>We cannot:</p>
                <ul>
                  <li className={S.listItem}>{'\u2022'} Move personal belongings such as jewelry, photos, and clothes.</li>
                  <li className={S.listItem}>{'\u2022'} Move pianos, aquariums, waterbeds, antiques, pool tables, holiday decorations, free standing gas heating units, large exercise equipment, safes.</li>
                  <li className={S.listItem}>{'\u2022'} Remove, replace or reconnect baseboard heaters and wall mounted radiators.</li>
                  <li className={S.listItem}>{'\u2022'} Move any electronics (If it has a power cord it will need to be moved prior to install).</li>
                  <li className={S.listItem}>{'\u2022'} If the customer asks for details (computers, stereos, home theaters, televisions, medical equipment, alarm systems, mechanical beds and living room furniture etc).</li>
                </ul>
              </Fragment>}
              <br />
              <p className={S.scriptUserNote}>
                USER NOTE: Go over any specific customer responsibilities found on the Detail.
              </p>
              {!lhiScript || surfaceId === 2 ? null : (<Fragment>
                <br />
                {[3, 7].includes(surfaceId) ? (<p className={S.scriptUserNote}>
                  USER NOTE: If project is 150sqft or more, the product will need to be picked up by the customer or delivered by Lowe{'\''}s before the appointment.
                </p>) : (<p>
                  Have all of your materials been delivered and are they inside the home for acclimation?
                </p>)}
              </Fragment>)}
              <br />
              <p>Do you have any questions for us at this time?</p>
              {lhiScript && surveyElement}
              <br />
              <p>
                Do you have our customer care number in case you need anything during your installation?
              </p>
              <br />
              <p>We look forward to helping you complete your project.</p>
              <br />
              <p>Thank you and have a great day!</p>
            </DropdownDiv>
          </ContainerDiv>}
        </Fragment>) : (<Fragment>
          <p>
            Just a reminder that if we are moving furniture,
            please remove all of your personal items, breakables, and electronics prior to the installer{'\''}s arrival.
          </p>
          {surfaceId !== 2 && <Fragment>
            <br />
            <p>
              I need to confirm that all the materials have been delivered or picked up and are in the home acclimating so we can move forward with the installation as scheduled.
            </p>
          </Fragment>}
          <br />
          <p>
            If any of this information is incorrect, please call us back at {SPIG_PHONE_NUMBER} or you can chat with us at serviceprosig.com.
          </p>
          {lhiScript && surveyElement}
          <br />
          <p>We look forward to helping you complete your project. Thank you and have a great day!</p>
        </Fragment>)}
      </Fragment>)}
    </div>
  </Card>);
};

JobReviewScript.propTypes = {
  title: PropTypes.string,
  phase: PropTypes.object,
  originalFurnitureStatus: PropTypes.bool,
  customerAnswered: PropTypes.string,
  movingFurniture: PropTypes.string,
  handleSpecificAnswered: PropTypes.func,
};

export default JobReviewScript;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseCommunications/components/jobReviewScript.jsx